import "./segmented.scss"

/**
 * Compact segmented (tab) control - a pill with one active segment. A lighter,
 * faster alternative to a 2-3 option Select (e.g. Return / One way).
 *
 * `options` is a { key: label } map; `selected` is the active key; `onSelect`
 * is called with { option } to match the app's other selects.
 */
export default function Segmented({ options, selected, onSelect, className }) {
	return (
		<div className={["ui-segmented", className].filter(Boolean).join(" ")} role="tablist">
			{Object.entries(options).map(([key, label]) => (
				<button
					key={key}
					type="button"
					role="tab"
					aria-selected={selected === key}
					className={["ui-segmented-option", selected === key ? "is-active" : ""].join(" ").trim()}
					onClick={() => onSelect({ option: key })}>
					{label}
				</button>
			))}
		</div>
	)
}
